export class ChemicalDbPermissionModel {
    roleId: any;
    location_Add: boolean = false;
    location_Edit: boolean = false;
    location_Delete: boolean = false;
    location_View: boolean = false;
    location_AddSubstance: boolean = false;
    sdsManager_Upload: boolean = false;
    sdsManager_Edit: boolean = false;
    sdsManager_Delete: boolean = false;
    sdsManager_View: boolean = false;
    sdsManager_Print: boolean = false;
    sdsManager_ViewPortal: boolean = false;
    sdsManager_AddFromPortal: boolean = false;
    riskAnalysis_Add: boolean = false;
    riskAnalysis_Edit: boolean = false;
    riskAnalysis_View: boolean = false;
    exposureForm_Add: boolean = false;
    exposureForm_Manager: boolean = false;
    exposureForm_WorkAssignment: boolean = false;
    // exposureForm_WorkAssignmentManager: boolean;
    workAssignment_WorkAssignmentManager: boolean = false;
    workAssignment_ShowExecutiveInformation: boolean = false;
    workAssignment_EditAndDuplicateWA: boolean = false;
    workAssignment_SeeRegistrations: boolean = false;
    workAssignment_ViewAllWorkAssignment: boolean = false;

    // View all risk measure task(s)
    taskManager_ViewAll: boolean = false;

    // Risk measure task(s) manager
    taskManager_EditAllRiskTask: boolean = false;

    taskManager_AccessSubstitutionModule: boolean = false;
    taskManager_ViewAllSubstitutionTask: boolean = false;
    taskManager_SubstitutionManager: boolean = false;
    project_View: boolean = false;
    project_Manage: boolean = false;
    hub_View: boolean = false;
    hub_Manage: boolean = false;

    admin_View: boolean = false;
    others_Print: boolean = false;
    others_ReadAllDepartments: boolean = false;
    others_ReadOnlyLocationAndChemical: boolean = false;
    others_Administrator: boolean = false;
    others_SDSCreator: boolean = false;
    report_Exposure: boolean = false;
    report_ShowIDAndWorkTitle: boolean = false;
    report_RiskAssessment: boolean = false;
    report_Stock: boolean = false;
    report_Substitution: boolean = false;

    anonymous_ReadAllURL: boolean = false;

    userAccess_LocalEdit: boolean = false;
    userAccess_FullEdit: boolean = false;
}
